import axios from 'axios';
import { useEffect, useState } from 'react';
import { Button, Col, Container, Form, Row, Table } from 'react-bootstrap';
import { root_url } from '../setting';
import { getBearerString } from '../utils/Auth';
import PaginationCompAdminPayment from './PaginationCompAdminPayment';

const AdminReceptionist = ({ history }) => {
  const styles = {
    backgroundColor: `rgb(228, 6, 19)`,
    color: 'white',
  };
  const ellipsis = {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  };
  const [isLoading, setIsLoading] = useState(true);
  const [result, setResult] = useState([]);
  const [ticketInfo, setTicketInfo] = useState([]);
  const [info, setInfo] = useState({
    joinerName: '',
    joinSeq: '',
    gender: '',
    cellphone: '',
    ticketSeq: '',
    pageNo: 1,
    size: 10,
  });
  const [pageInfo, setPageInfo] = useState({
    pageNo: 1,
    pageMaxNo: 0,
  });

  const getFetchData = async (obj) => {
    let postDOM = {};
    let params = '';
    if (pageInfo.pageNo != null && pageInfo.pageNo != '') {
      postDOM.pageNo = pageInfo.pageNo;
      params += 'pageNo=' + 1 + '&';
    }
    if (obj.size != null && obj.size != '') {
      postDOM.size = obj.size;
      params += 'rowCount=' + obj.size + '&';
    }
    if (obj.joinerName != null && obj.joinerName != '') {
      postDOM.joinerName = obj.joinerName;
      params += 'joinerName=' + obj.joinerName + '&';
    }
    if (obj.gender != null && obj.gender != '') {
      postDOM.gender = obj.gender;
      params += 'gender=' + obj.gender + '&';
    }
    if (obj.cellphone != null && obj.cellphone != '') {
      postDOM.cellphone = obj.cellphone;
      params += 'cellphone=' + obj.cellphone + '&';
    }
    if (obj.ticketSeq != null && obj.ticketSeq != '') {
      postDOM.ticketSeq = obj.ticketSeq;
      params += 'ticketSeq=' + obj.ticketSeq + '&';
    }
    if (obj.joinSeq != null && obj.joinSeq != '') {
      postDOM.joinSeq = obj.joinSeq;
      params += 'joinSeq=' + obj.joinSeq + '&';
    }
    // 맨 마직막 & 없애기
    if (params.length > 0) {
      params = params.substring(0, params.length - 1);
    }
    console.log('param >>>>', params);
    let accessToken = getBearerString();
    let headers = {
      headers: {
        Authorization: accessToken,
      },
    };
    try {
      console.log('버튼 클릭', accessToken);
      let response = await axios.get(`${root_url}/api/admin/reception/search?${params}`, headers);
      console.log('## response.data ##', response.data);
      setPageInfo({ pageNo: 1, pageMaxNo: response.data.pageMaxNo });
      setResult(response.data.applications);
      history.push(`/admin/reception/receptionist?${params}`);
    } catch (e) {
      if (e?.response?.status === 403) {
        alert('권한이 존재하지 않습니다.');
        localStorage.setItem('accessToken', '');
        window.location.href = '/admin/login';
      }

      if (e.response === undefined) {
        alert('시스템 서비스가 원할하지 않습니다. 관리자에게 문의하세요. (code - A0001)');
      } else {
        alert(e.response.data.errorMessage);
      }
      console.log(e.response);
    }
  };
  const getTicketInfo = async () => {
    try {
      let response = await axios.get(`${root_url}/api/join/ticket-info`);

      setTicketInfo(response.data);
    } catch (e) {
      if (e.response === undefined) {
        alert('시스템 서비스가 원할하지 않습니다. 관리자에게 문의하세요. (code - A0001)');
      } else {
        alert(e.response.data.errorMessage);
      }
      console.log(e.response);
    }
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('### info ###', info);
    getFetchData(info);
  };
  const fetchDataURL = async () => {
    const params = window.location.toString().split('?')[1];
    const pageNo = params.split('&')[0].split('=')[1];
    console.log('params >>> ', params, ' pageNo >>> ', pageNo);
    let accessToken = getBearerString();
    let headers = {
      headers: {
        Authorization: accessToken,
      },
    };
    try {
      console.log('페이지 인입', accessToken);
      let response = await axios.get(`${root_url}/api/admin/reception/search?${params}`, headers);
      console.log('## response.data ##', response.data);
      setPageInfo({ pageNo: pageNo, pageMaxNo: response.data.pageMaxNo });
      setResult(response.data.applications);
      history.push(`/admin/reception/receptionist?${params}`);
    } catch (e) {
      if (e?.response?.status === 403) {
        alert('권한이 존재하지 않습니다.');
        localStorage.setItem('accessToken', '');
        window.location.href = '/admin/login';
      }
      if (e.response === undefined) {
        alert('시스템 서비스가 원할하지 않습니다. 관리자에게 문의하세요. (code - A0001)');
      } else {
        alert(e.response.data.errorMessage);
      }
      console.log(e.response);
    }
    setIsLoading(false);
  };
  const downloadExcel = async () => {
    const params = window.location.toString().split('?')[1];
    console.log('>>> downloadExcel');
    // TODO
    try {
      let accessToken = getBearerString();

      fetch(`${root_url}/api/admin/reception/search/excel?${params}`, {
        headers: {
          Authorization: accessToken,
        },
      })
        .then((response) => {
          if (response.ok) {
            return response.blob().then((blob) => {
              return {
                blob,
                contentDispostition: response.headers.get('Content-Disposition'),
              };
            });
          } else {
            throw new Error('Network response was not ok.');
          }
        })
        .then(({ blob, contentDispostition }) => {
          // Blob을 이용하여 파일 다운로드
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          // 다운로드될 파일 이름
          a.download = contentDispostition.at('filename=')
            ? contentDispostition.split('filename=')[1]
            : 'download.xlsx';
          a.click();
          document.body.removeChild(a);
          window.URL.revokeObjectURL(url);
        })
        .catch((error) => {
          console.log('error: ', error);
        });
    } catch (e) {
      if (e?.response?.status === 403) {
        alert('권한이 존재하지 않습니다.');
        localStorage.setItem('accessToken', '');
        window.location.href = '/admin/login';
      }
      if (e.response === undefined) {
        alert('시스템 서비스가 원할하지 않습니다. 관리자에게 문의하세요. (code - A0001)');
      } else {
        alert(e.response.data.errorMessage);
      }
      console.log(e.response);
    }
  };
  const onClickRow = (joiner) => {
    if (joiner.exponent === null || joiner.exponent === '') {
      // 개인 접수 수정 페이지로 리다이렉트
      window.location.href = '/admin/reception/application/individual?joinSeq=' + joiner.joinSeq;
    } else {
      // 단체 접수 수정 페이지로 리다이렉트
      window.location.href = '/admin/reception/application/group?joinSeq=' + joiner.joinSeq;
    }
  };
  useEffect(() => {
    fetchDataURL();
    getTicketInfo();
  }, [window.location.toString()]);
  return (
    <Container>
      <h1 id="outline" className="mt-5 pt-3 text-center">
        신청관리
      </h1>
      <Form inline onSubmit={handleSubmit}>
        <Row>
          <Col>
            <Form.Control
              type="input"
              placeholder="신청자, 단체명, 참가자"

              onChange={(e) => {
                let joinerName = e.target.value;
                setInfo({ ...info, joinerName: joinerName });
              }}
            ></Form.Control>
          </Col>
          <Col>
            <Form.Control
              type="input"
              placeholder="접수번호"
              onChange={(e) => {
                setInfo({ ...info, joinSeq: e.target.value });
              }}
            ></Form.Control>
          </Col>
          <Col>
            <Form.Control
              type="input"
              placeholder="전화번호"
              onChange={(e) => {
                let cellphone = e.target.value;
                setInfo({ ...info, cellphone: cellphone });
              }}
            ></Form.Control>
          </Col>
        </Row>
        <Row className="mt-3">
          <Col>
            <Form.Control
              as="select"
              className="my-1 mr-sm-2"
              custom
              onChange={(e) => {
                let gender = e.target.value;
                setInfo({ ...info, gender: gender });
              }}
            >
              <option value="">성별</option>
              <option value="M">남자</option>
              <option value="F">여자</option>
            </Form.Control>
          </Col>
          <Col>
            <Form.Control
              as="select"
              onChange={(e) => {
                let ticketSeq = e.target.value;
                setInfo({ ...info, ticketSeq: ticketSeq });
              }}
              custom
            >
              <option value="">참가종목</option>
              {ticketInfo.map((ticket, key) => {
                return <option key={key} value={ticket.ticketSeq}>{ticket.ticketName}</option>;
              })}
            </Form.Control>
          </Col>
          <Col>
            <Row>
              <Col>
                <Button
                  className="w-100 mb-2"
                  type="submit"
                >
                  검색
                </Button>
              </Col>
              <Col>
                <Button
                  className="w-100"
                  onClick={() => {
                    downloadExcel();
                  }}
                >
                  엑셀 변환
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
      </Form>
      <Row>
        <Col>
          <h5 className="mt-3">검색 결과</h5>
        </Col>
        <Col className="col-2">
          <Form.Control
            as="select"
            onChange={(e) => {
              let size = e.target.value;
              setInfo({ ...info, size: size });
            }}
          >
            <option value="10">10줄</option>
            <option value="20">20줄</option>
            <option value="30">30줄</option>
            <option value="40">40줄</option>
            <option value="50">50줄</option>
          </Form.Control>
        </Col>
      </Row>
      <div style={{ overflowX: 'scroll', marginBottom: '30px' }}>
        <Table bordered className="text-center" style={{ minWidth: '700px' }}>
          <thead>
            <tr style={styles} className="bg-custom-color">
              <th>접수번호</th>
              <th>접수자명</th>
              <th>팀명</th>
              <th>결제구분</th>
              <th>결제방법</th>
              <th>참가자</th>
              <th>전화번호</th>
              <th>생년월일</th>
              <th>종목</th>
              <th>기념품</th>
              <th>수령지</th>
            </tr>
          </thead>
          <tbody>
            {result.map((joiner, key1) => {
              return (
                <>
                  {joiner.runners.map((runner, key2) => {
                    return (
                      <tr
                        style={{ verticalAlign: 'middle', cursor: 'pointer' }}
                        onClick={() => {
                          onClickRow(joiner);
                        }}
                        key={key2}
                      >
                        <td>{joiner.joinSeq}</td>
                        <td>{joiner.joinerName}</td>
                        <td>{joiner.exponent}</td>
                        <td>
                          {joiner.paymentStatus == 'RSVT'
                            ? '입금대기'
                            : joiner.paymentStatus == 'CMPL'
                              ? '입금완료'
                              : '참가취소'}
                        </td>
                        <td>{joiner.paymentType == 'BANK' ? '계좌이체' : '카드결제'}</td>
                        <td>{runner.runnerName}</td>
                        <td>{runner.cellphone}</td>
                        <td>{runner.birthday}</td>
                        <td>{runner.ticketName}</td>
                        <td>
                          {runner.souvenir == null
                            ? '-'
                            : runner.souvenir + '(' + runner.choiceOption + ')'}
                        </td>
                        <td>{joiner.zipAddress + ', ' + joiner.address}</td>
                      </tr >
                    );
                  })}
                </>
              );
            })}
          </tbody>
        </Table>
      </div>
      {
        isLoading ? (
          ''
        ) : (
          <PaginationCompAdminPayment
            pageMaxNo={pageInfo.pageMaxNo}
            active={pageInfo.pageNo}
            history={history}
            url="receptionist"
          />
        )
      }
    </Container >
  );
};

export default AdminReceptionist;
